import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { funnyQuotes } from '@/mocks/home';

export default function Jokes() {
  const [index, setIndex] = useState(0);
  const [copied, setCopied] = useState(false);

  const current = funnyQuotes[index];

  const next = () => {
    setIndex((prev) => (prev + 1) % funnyQuotes.length);
    setCopied(false);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(current.text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="jokes" className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="日常段子"
          title="生活的鸡毛蒜皮，也值得一句好笑"
          desc="挑一句发出去，说不定对面那个正在吃瓜的人，刚好也需要笑一下。"
        />

        <div className="mt-10 md:mt-14 max-w-3xl mx-auto">
          <div className="relative rounded-lg bg-background-50 border border-secondary-200 p-6 md:p-10 text-center">
            <i className="ri-double-quotes-l text-4xl md:text-5xl text-secondary-300" />
            <p className="mt-4 md:mt-6 font-heading text-xl md:text-3xl leading-relaxed text-foreground-950">
              {current.text}
            </p>
            <span className="inline-block mt-5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
              #{current.tag}
            </span>

            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
              <button
                type="button"
                onClick={next}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-refresh-line" />
                换一条
              </button>
              <button
                type="button"
                onClick={copy}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-800 text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'} />
                {copied ? '已复制' : '复制这句'}
              </button>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap justify-center gap-2">
            {funnyQuotes.map((joke, i) => (
              <button
                key={joke.id}
                type="button"
                onClick={() => {
                  setIndex(i);
                  setCopied(false);
                }}
                className={`px-3 py-1.5 rounded-full text-xs transition-colors ${
                  i === index
                    ? 'bg-foreground-900 text-background-50'
                    : 'bg-background-50 text-foreground-500 border border-secondary-200 hover:text-foreground-900'
                }`}
                aria-label={`查看第 ${i + 1} 条段子`}
              >
                {String(i + 1).padStart(2, '0')}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}